import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { RewardsComponent } from './rewards.component';
import { SharedModule } from '../shared/shared.module';
import { RewardsLogIndividualComponent } from './rewards-log-individual/rewards-log-individual.component';
import { RewardsLogTotalsComponent } from './rewards-log-totals/rewards-log-totals.component';

const routes: Routes = [
  {
    path: '',
    component: RewardsComponent
  },
  {
    path: ':tab',
    component: RewardsComponent
  }
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    RewardsComponent,
    RewardsLogIndividualComponent,
    RewardsLogTotalsComponent,
  ]
})
export class RewardsModule { }
